import Adventure from './img/vis/illustration/adventure.png';
import AdventureCU from './img/vis/illustration/adventureCU.png';
import Meowth from './img/vis/illustration/meowth.png';
import Patrice from './img/vis/illustration/patrice.png';
import PixelCharacter from './img/vis/illustration/pixelCharacter.png';
import PixelEnvironment from './img/vis/illustration/pixelEnvironment.png';
import { Component } from "react";
import { Link } from "react-router-dom";


const images = [
    Adventure,
    AdventureCU,
    Meowth,
    Patrice,
    PixelCharacter,
    PixelEnvironment
]


class ImageGallery extends Component {
    constructor(props){
        super(props)
        this.state = {imageIndex:0}
    }
    render(){
        return(
            <div className="projectContent">
                <ImageDisplay imageIndex={this.state.imageIndex}></ImageDisplay>
            </div>
        )
    }
}

function ImageDisplay(props){
    return(
        <div>
            <Link to='/visual'>
                <div className="projectPageContainer" onClick={e=>alert('onlock bg')}></div>
            </Link>
            <img src={images[props.imageIndex]} className="image"/>
        </div>
    )
}


function ProjectPage(props) {
    return (
        <div>
            <Link to='/visual'>
                <div className="projectPageContainer"></div>
            </Link>

            <div className="projectPageMenu">
                <Link to='/visual'><CloseButton /></Link>
                <div className="subheader projectTitle">{props.title}</div>
                <div className="projectBody">
                    {props.children}
                </div>
            </div>
        </div>
    )
}

function CloseButton() {
    return (
        <div className="xButton"
            onClick={e=>alert('ow')}>
            x
        </div>
    )
}

export {ImageGallery}